// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import BlogPostQuoteStyles from './blogPostQuote.styles';

export default function BlogPostQuote({ layout }) {
  const quote = layout?.quote;
  const attribution = layout?.attribution;

  return (
    <BlogPostQuoteStyles>
      <p className="quote">{quote}</p>
      {!!attribution && <h4 className="attribution">&mdash; {attribution}</h4>}
    </BlogPostQuoteStyles>
  );
}

BlogPostQuote.propTypes = {
  layout: PropTypes.shape({
    quote: PropTypes.string,
    attribution: PropTypes.string,
  }),
};

BlogPostQuote.defaultProps = {
  layout: {},
};
